import SiteLayout from '@/components/feature/SiteLayout';
import ServiceDetail from '@/components/feature/ServiceDetail';
import NotFound from '@/pages/NotFound';
import { serviceDetails } from '@/mocks/services';

export default function ServiceDetailPage({ slug }: { slug: string }) {
  const service = serviceDetails.find((s) => s.slug === slug);
  if (!service) return <NotFound />;
  return (
    <SiteLayout>
      <title>{`${service.name} | CLEARY Home Cleaning`}</title>
      <meta name="description" content={`${service.valueProp} Learn what is included in CLEARY ${service.name.toLowerCase()} and request a quote.`} />
      <ServiceDetail key={service.slug} service={service} />
    </SiteLayout>
  );
}